import React, { useState, useEffect } from "react";
import { currentDateFormat } from "../utils";
import * as XLSX from "xlsx";
import axios from "axios";
import { UPLOAD_SCHEDULE, GET_ALL_PAYER, GET_PASSENGER, UPDATE_PASSENGER_DATA } from "../constant";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from "../messageBox/customSweetAlert";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import { convertShortTime } from "../utils";
import ReusableModal from "../components/ModalContent/ReusableModal";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ScheduleUploading() {
  const dispatch = useDispatch();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedPair, setSelectedPair] = useState("");
  const [payerList, setPayerList] = useState([]);
  const [skippedReason, setSkippedReason] = useState([]);
  const loading = useSelector((state) => state.loader.loading);
  const [isLoading, setIsLoading] = useState(false);
  const [showSkippedRecords, setShowSkippedRecords] = useState(false);
  const [skippedCount, setSkippedCount] = useState(0);
  const [totalRecordsWithMissingdata, setTotalRecordsWithMissingdata] = useState(0);
  const [totalRecordsWithMissingdatas, setTotalRecordsWithMissingdatas] = useState([]);
  const [showMissingPassengerData, setShowMissingPassengerData] = useState(false);
  const [openPassengerModal, setOpenPassengerModal] = useState(false);
  const [selectedPassengerId, setSelectedPassengerId] = useState(null);
  const [passengerData, setPassengerData] = useState({
    first_name: "",
    gender: "",
    user_dob: ""
  });
  const [selectedDob, setSelectedDob] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);


  useEffect(() => {
    const loadUser = async () => {
      const response_payer = await axios.get(GET_ALL_PAYER);
      setPayerList(response_payer.data);
    };
    loadUser();
  }, []);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
    setSkippedReason([]);
    setShowSkippedRecords(false);
    setSkippedCount(0);
    setTotalRecordsWithMissingdata(0);
    setTotalRecordsWithMissingdatas([]);
    setShowMissingPassengerData(false);
  };
  const handlePairChange = (e) => {
    setSelectedPair(e.target.value);
    setMessage("");
    setShowSkippedRecords(false);
    setSkippedReason([]);
    setSkippedCount(0);
    setTotalRecordsWithMissingdata(0);
    setTotalRecordsWithMissingdatas([]);
    setShowMissingPassengerData(false);
    setOpenPassengerModal(false);
    setSelectedPassengerId(null);
  };

  const handleUpdateClick = async (passengerId) => {
    setSelectedPassengerId(passengerId);
    setOpenPassengerModal(true);
    dispatch(setLoading(true));

    try {
      const response = await axios.get(`${GET_PASSENGER}/${passengerId}`);
      if (response?.data?.status === "200" || response?.data) {
        const data = response?.data?.data || response?.data;
        // Convert date from YYYY-MM-DD to Date object for DatePicker
        let dobDate = null;
        let formattedDob = "";
        if (data.user_dob) {
          const date = moment(data.user_dob);
          if (date.isValid()) {
            dobDate = date.toDate();
            formattedDob = date.format("MM/DD/YYYY");
          } else {
            formattedDob = data.user_dob;
          }
        }
        setSelectedDob(dobDate);
        setPassengerData({
          first_name: data.first_name,
          gender: data.gender,
          user_dob: formattedDob
        });
      }
    } catch (error) {
      console.error("Error fetching passenger data:", error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message || "Failed to fetch passenger details",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handlePassengerInputChange = (e) => {
    const { name, value } = e.target;
    setPassengerData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDobChange = (date) => {
    setSelectedDob(date);
    if (date) {
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      const yyyy = String(date.getFullYear());
      const formatted = `${mm}/${dd}/${yyyy}`;
      setPassengerData(prev => ({
        ...prev,
        user_dob: formatted
      }));
    } else {
      setPassengerData(prev => ({
        ...prev,
        user_dob: ""
      }));
    }
  };

  const handleUpdatePassenger = async () => {
    if (!selectedPassengerId) return;

    setIsUpdating(true);
    dispatch(setLoading(true));

    try {
      // Payload date format should be MM/DD/YYYY as requested
      const payload = { ...passengerData };

      const response = await axios.patch(`${UPDATE_PASSENGER_DATA}/${selectedPassengerId}`, payload);

      if (response?.data?.status === "200" || response?.status === 200) {
        // Remove the updated passenger from the missing data list
        const updatedMissingData = totalRecordsWithMissingdatas.filter(
          (item) => item?.user_id !== selectedPassengerId
        );
        setTotalRecordsWithMissingdatas(updatedMissingData);
        const newCount = updatedMissingData.length;
        setTotalRecordsWithMissingdata(newCount);
        
        // Hide the table if all records are updated
        if (newCount === 0) {
          setShowMissingPassengerData(false);
        }
        
        Swal.fire({
          title: "Success!",
          text: response?.data?.message || "Passenger data updated successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
        setOpenPassengerModal(false);
        setSelectedPassengerId(null);
      } else {
        Swal.fire({
          title: "Error!",
          text: response?.data?.message || "Failed to update passenger data",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Error updating passenger data:", error);
      Swal.fire({
        title: "Error!",
        text: error?.response?.data?.message || "An error occurred while updating passenger data",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setIsUpdating(false);
      dispatch(setLoading(false));
    }
  };

  const handleCloseModal = () => {
    setOpenPassengerModal(false);
    setSelectedPassengerId(null);
    setSelectedDob(null);
    setPassengerData({
      first_name: "",
      gender: "",
      user_dob: ""
    });
  };
  const handleUpload = () => {
    if (!file) {
      setMessage("Please select a file to upload.");
      return;
    }
    setMessage("");
    const now = new Date();

    const formData = new FormData();
    formData.append('file', file);
    // Extract parts and ensure they have two digits using padStart
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    const yyyy = now.getFullYear();
    // Time Parts (24-hour format)
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const ss = String(now.getSeconds()).padStart(2, '0');
    // Combine: MM-DD-YYYY_HH-mm-ss_filename.ext
    const timestamp = `${mm}-${dd}-${yyyy}_${hh}-${min}-${ss}`;
    const fileName = `${timestamp}_${file.name.toLowerCase()}`;
    const fileSizeInBytes = file.size;
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(fileSizeInBytes) / Math.log(k));
    const fileSize = parseFloat((fileSizeInBytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    const fileExtension = file.name.split('.').pop();
    const fileType = file.type;
    // const fileName = file.name.toLowerCase();

    // Determine expected string in file name based on selected payer
    const expectedKeyword =
      selectedPair === "1" ? "mtm" : selectedPair === "2" ? "ucare" : "";

    // Check if the expected keyword is in the file name
    // if (!fileName.includes(expectedKeyword)) {
    //     setMessage(`Error: The uploaded file name does not match the selected payer "${expectedKeyword.toUpperCase()}".`);
    //     return;
    // }
    const reader = new FileReader();
    reader.onload = async (event) => {
      dispatch(setLoading(true));
      setIsLoading(true);
      try {
        // Parse workbook and rows
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        // Find the real header row: first row with several non-empty cells (skips title/empty rows)
        const rowsAoA = XLSX.utils.sheet_to_json(firstSheet, {
          header: 1,
          defval: "",
          blankrows: false,
        });
        const headerRowIndex = rowsAoA.findIndex(
          (r) =>
            Array.isArray(r) &&
            r.filter((c) => String(c).trim() !== "").length >= 3
        );
        const safeHeaderRowIndex = headerRowIndex >= 0 ? headerRowIndex : 0;
        const headerRow = Array.isArray(rowsAoA[safeHeaderRowIndex])
          ? rowsAoA[safeHeaderRowIndex]
          : [];
        const trimmedHeader = headerRow.map((h) => String(h).trim());

        // Build JSON using the detected header row; start reading data after the header row
        let jsonData = XLSX.utils.sheet_to_json(firstSheet, {
          header: trimmedHeader,
          range: safeHeaderRowIndex + 1,
          defval: "",
          blankrows: false,
        });

        // Clean up any stray __EMPTY* keys and drop fully empty rows
        jsonData = jsonData
          .map((row) => {
            const cleaned = {};
            Object.keys(row).forEach((k) => {
              if (!k || k.startsWith("__EMPTY")) return;
              const nk = String(k).trim();
              cleaned[nk] = row[k];
            });
            return cleaned;
          })
          .filter((row) =>
            Object.values(row).some((v) => String(v).trim() !== "")
          );

        // Normalize date fields
        const dateKeys = ["Appointment Date", "Date of Birth", "Date", "DOB"];
        jsonData.forEach((row) => {
          dateKeys.forEach((key) => {
            if (typeof row[key] === "number") {
              const parsedDate = XLSX.SSF.parse_date_code(row[key]);
              if (parsedDate) {
                const date = new Date(
                  parsedDate.y,
                  parsedDate.m - 1,
                  parsedDate.d,
                  parsedDate.H,
                  parsedDate.M,
                  parsedDate.S
                );
                row[key] = date.toLocaleDateString("en-US");
              }
            }
          });
        });

        // Upload to backend
        const payload = {
          data: jsonData,
          pair: selectedPair,
          file:{fileName, fileSize,fileType:fileExtension ?? fileType}
        };
        formData.append('data', JSON.stringify(payload));
        const response = await axios.post(UPLOAD_SCHEDULE, formData,payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response?.data?.status === "200") {
          setIsLoading(false);
          setSkippedReason(response?.data?.skippedRecords || []);
          setSkippedCount(response?.data?.skippedCount ?? 0);
          setShowSkippedRecords(false); // Reset to hide table initially
          setTotalRecordsWithMissingdata(response?.data?.totalRecordsWithMissingdata ?? 0);
          setTotalRecordsWithMissingdatas(response?.data?.totalRecordsWithMissingdatas || []);
          setShowMissingPassengerData(false); // Reset to hide table initially
          Swal.fire({
            title: "Completed",
            text: response?.data?.message || "Upload completed successfully",
            icon: "success",
            confirmButtonText: "OK",
          });
          setMessage(`<span style=\"color: green;\">Records processed : ${response?.data?.processedRecords ?? 0
            }</span><br />
                                <span style=\"color: green;\">New records added: ${response?.data?.insertedCount ?? 0
            }</span>`);
          setFile(null);
          const input = document.getElementById("fileInput");
          if (input) input.value = "";
        } else {
          setIsLoading(false);
          Swal.fire({
            title: "Error!",
            text:
              response?.data?.message ||
              "Upload failed. Please verify your file and try again.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.log(error);
        setIsLoading(false);
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred while uploading.";
        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
        // Clear the file so user can pick again (even same file)
        setFile(null);
        const input = document.getElementById("fileInput");
        if (input) input.value = "";
      } finally {
        setIsLoading(false);
        dispatch(setLoading(false));
      }
    };
    reader.onerror = () => {
      setIsLoading(false);
      dispatch(setLoading(false));
      Swal.fire({
        title: "Error!",
        text: "Failed to read the selected file. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
      // Reset file input to recover without full page refresh
      setFile(null);
      const input = document.getElementById("fileInput");
      if (input) input.value = "";
    };
    reader.readAsArrayBuffer(file);
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (!selectedPair) {
      e.preventDefault();
      setMessage("Please select a payer first.");
    } else {
      handleUpload();
    }
  };

  return (
    <div
      className="tab-pane fade active show"
      id="add-passenger"
      role="tabpanel"
      aria-labelledby="home-tab"
    >
      <section>
        <div className="d-flex justify-content-between form-container">
          <div>
            <h2 className="fs-5 font-weight-600"> Schedule Upload</h2>
          </div>
          <div>
            <span>{currentDateFormat(currentDate)}</span>
          </div>
        </div>
      </section>
      <section>
        <div className="bg-white  px-5 py-4">
          {/* Combined Input Fields Card */}
          <div style={{
            background: "#fff",
            borderRadius: "12px",
            border: "1px solid #e0e0e0",
            padding: "24px",
            marginBottom: "20px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)"
          }}>
            <div style={{
              display: "flex",
              gap: "24px",
              alignItems: "flex-end",
              flexWrap: "wrap"
            }}>
              {/* Select Payer Field */}
              <div style={{ flex: "1", minWidth: "250px" }}>
                <label className="require-field" style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151"
                }}>
                  Select Payor
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  onChange={handlePairChange}
                  value={selectedPair}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    fontSize: "14px"
                  }}
                >
                  <option>Select</option>
                  <option value="1">MTM</option>
                  <option value="2">UCARE</option>
                  <option value="3">PRIVATE PAY</option>
                  <option value="4">MA</option>
                </select>
              </div>

              {/* Select Files Field */}
              <div style={{ flex: "1", minWidth: "250px" }}>
                <label className="require-field" style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151"
                }}>
                  Select Files
                </label>
                <input
                  type="file"
                  id="fileInput"
                  className="form-control"
                  onChange={handleFileChange}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    border: "1px solid #d1d5db",
                    fontSize: "14px"
                  }}
                />
              </div>

              {/* Upload Button */}
              <div style={{ flexShrink: 0 }}>
                <button
                  className="btn rounded-1"
                  style={{
                    background: "#31876f",
                    color: "#fff",
                    border: "none",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontWeight: "500",
                    fontSize: "14px",
                    whiteSpace: "nowrap"
                  }}
                  onClick={handleButtonClick}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Processing...
                    </>
                  ) : (
                    "UPLOAD"
                  )}
                </button>
              </div>
            </div>
          </div>

          {message && message.trim() !== "" && (
            <div style={{ marginTop: "30px" }}>
              {/* Status Cards Section - 4 Cards in a Row */}
              <div style={{
                display: "flex",
                justifyContent: "space-evenly",
                gap: "20px",
                marginBottom: "30px",
                flexWrap: "wrap",

              }}>
                {/* Records Processed Card */}
                <div style={{
                  background: "#3B8D82",
                  borderRadius: "16px",
                  padding: "24px",
                  color: "#fff",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  minWidth: "280px",
                  maxWidth: "320px",
                  minHeight: "180px",
                  flex: "1",
                  position: "relative",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}>
                  <div style={{
                    width: "35px",
                    height: "30px",
                    background: "rgba(255, 255, 255, 0.25)",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    marginBottom: "12px"
                  }}>📊</div>
                  <div style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    opacity: 0.95,
                    marginBottom: "8px"
                  }}>
                    RECORDS PROCESSED
                  </div>
                  <div style={{ fontSize: "36px", fontWeight: "bold", lineHeight: "1" }}>
                    {message.match(/Records processed : (\d+)/)?.[1] || "0"}
                  </div>
                </div>

                {/* New Records Added Card */}
                <div
                  className="status-card"
                  style={{
                    background: "#34A87E",
                    borderRadius: "16px",
                    padding: "24px",
                    color: "#fff",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    minWidth: "280px",
                    maxWidth: "320px",
                    minHeight: "180px",
                    flex: "1",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}>
                  <div style={{
                    width: "35px",
                    height: "30px",
                    background: "rgba(255, 255, 255, 0.25)",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    marginBottom: "12px"
                  }}>✅</div>
                  <div style={{
                    fontSize: "11px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    opacity: 0.95,
                    marginBottom: "8px"
                  }}>
                    NEW RECORDS ADDED
                  </div>
                  <div style={{ fontSize: "36px", fontWeight: "bold", lineHeight: "1" }}>
                    {message.match(/New records added: (\d+)/)?.[1] || "0"}
                  </div>
                </div>

                {/* Passenger Missing Data Card */}
                {totalRecordsWithMissingdata > 0 && (
                  <div style={{
                    background: "#F59E0B",
                    borderRadius: "16px",
                    padding: "24px",
                    color: "#fff",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    minWidth: "280px",
                    maxWidth: "320px",
                    minHeight: "180px",
                    flex: "1",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}>
                    <div>
                      <div style={{
                        width: "35px",
                        height: "30px",
                        background: "rgba(255, 255, 255, 0.25)",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "20px",
                        marginBottom: "12px"
                      }}>👤</div>
                      <div style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        letterSpacing: "0.5px",
                        opacity: 0.95,
                        marginBottom: "8px"
                      }}>
                        PASSENGER MISSING DATA
                      </div>
                      <div style={{ fontSize: "36px", fontWeight: "bold", lineHeight: "1", marginBottom: "16px" }}>
                        {totalRecordsWithMissingdata}
                      </div>
                    </div>
                    <button
                      onClick={() => setShowMissingPassengerData(!showMissingPassengerData)}
                      style={{
                        background: "rgba(255, 255, 255, 0.25)",
                        border: "none",
                        color: "#fff",
                        padding: "10px 16px",
                        height: "40px",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor: "pointer",
                        width: "100%",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px"
                      }}
                      onMouseEnter={(e) => e.target.style.background = "rgba(255, 255, 255, 0.35)"}
                      onMouseLeave={(e) => e.target.style.background = "rgba(255, 255, 255, 0.25)"}
                    >
                      {showMissingPassengerData ? "Hide Details" : "View Details →"}
                    </button>
                  </div>
                )}

                {/* Duplicate Records Card */}
                {skippedCount > 0 && (
                  <div style={{
                    background: "#DC2626",
                    borderRadius: "16px",
                    padding: "24px",
                    color: "#fff",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    minWidth: "280px",
                    maxWidth: "320px",
                    minHeight: "180px",
                    flex: "1",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between"
                  }}>
                    <div>
                      <div style={{
                        width: "35px",
                        height: "30px",
                        background: "rgba(255, 255, 255, 0.25)",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "20px",
                        marginBottom: "12px"
                      }}>📄</div>
                      <div style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        letterSpacing: "0.5px",
                        opacity: 0.95,
                        marginBottom: "8px"
                      }}>
                        DUPLICATE RECORDS
                      </div>
                      <div style={{ fontSize: "36px", fontWeight: "bold", lineHeight: "1", marginBottom: "16px" }}>
                        {skippedCount}
                      </div>
                    </div>
                    <button
                      onClick={() => setShowSkippedRecords(!showSkippedRecords)}
                      style={{
                        background: "rgba(255, 255, 255, 0.25)",
                        border: "none",
                        color: "#fff",
                        padding: "10px 16px",
                        height: "40px",
                        borderRadius: "8px",
                        fontSize: "13px",
                        fontWeight: "600",
                        cursor: "pointer",
                        width: "100%",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px"
                      }}
                      onMouseEnter={(e) => e.target.style.background = "rgba(255, 255, 255, 0.35)"}
                      onMouseLeave={(e) => e.target.style.background = "rgba(255, 255, 255, 0.25)"}
                    >
                      {showSkippedRecords ? "Hide Details" : "View Details →"}
                    </button>
                  </div>
                )}
              </div>

              {/* Duplicate Records Table Section */}
              {showSkippedRecords && skippedCount > 0 && skippedReason && skippedReason.length > 0 && (
                <div style={{
                  background: "#fff",
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                  padding: "20px",
                  marginBottom: "20px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)"
                }}>
                  <h5 style={{
                    marginBottom: "15px",
                    color: "#374151",
                    fontSize: "16px",
                    fontWeight: "600"
                  }}>
                    Skipped Records Details
                  </h5>
                  <div style={{ overflowX: "auto", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        background: "#fff"
                      }}
                    >
                      <thead>
                        <tr style={{ background: "#f9fafb" }}>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>#</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Passenger Name</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Driver Name</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Appointment Date</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Time Range</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {skippedReason.map((item, index) => (
                          <tr key={index} style={{
                            borderBottom: "1px solid #f3f4f6",
                            transition: "background 0.2s"
                          }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                            onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
                          >
                            <td style={{ padding: "12px 16px", color: "#6b7280", fontSize: "14px" }}>
                              {index + 1}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#1f2937", fontSize: "14px", fontWeight: "500" }}>
                              {item.row["Member's First Name"]
                                ? `${item.row["Member's First Name"] || ""} ${item.row["Member's Last Name"] || ""
                                }`
                                : `${item.row["Name"] || ""}`}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#6b7280", fontSize: "14px" }}>
                              {item.row["Driver Name"]
                                ? `${item.row["Driver Name"] || ""}`
                                : "N/A"}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#6b7280", fontSize: "14px" }}>
                              {item.row["Appointment Date"]
                                ? item.row["Appointment Date"]
                                : item.row["Date"]}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#6b7280", fontSize: "14px" }}>
                              {item.row["Time"]
                                ? `${convertShortTime(item.row["Time"])}`
                                : `${convertShortTime(
                                  item.row["P/U Time"]
                                )} - ${convertShortTime(
                                  item.row["Appt.Time"]
                                )}`}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#dc2626", fontSize: "14px", fontWeight: "500" }}>
                              {item.reason}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Missing Passenger Data Table Section */}
              {showMissingPassengerData && totalRecordsWithMissingdata > 0 && totalRecordsWithMissingdatas && totalRecordsWithMissingdatas.length > 0 && (
                <div style={{
                  background: "#fff",
                  borderRadius: "12px",
                  border: "1px solid #e0e0e0",
                  padding: "20px",
                  marginBottom: "20px",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)"
                }}>
                  <div style={{
                    background: "#fef2f2",
                    border: "1px solid #fecaca",
                    borderRadius: "8px",
                    padding: "12px 16px",
                    marginBottom: "20px"
                  }}>
                    <p style={{
                      color: "#dc2626",
                      fontSize: "14px",
                      margin: 0,
                      display: "flex",
                      alignItems: "center",
                      gap: "8px"
                    }}>
                      <span>⚠️</span>
                      <span>Please update the missing data for the passengers below.</span>
                    </p>
                  </div>
                  <h5 style={{
                    marginBottom: "15px",
                    color: "#374151",
                    fontSize: "16px",
                    fontWeight: "600"
                  }}>
                    Passenger Missing Data Details
                  </h5>
                  <div style={{ overflowX: "auto", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        background: "#fff"
                      }}
                    >
                      <thead>
                        <tr style={{ background: "#f9fafb" }}>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>#</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Passenger Name</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Missing Data</th>
                          <th style={{
                            padding: "12px 16px",
                            textAlign: "left",
                            fontWeight: "600",
                            color: "#374151",
                            fontSize: "14px",
                            borderBottom: "2px solid #e5e7eb"
                          }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {totalRecordsWithMissingdatas?.map((item, index) => (
                          <tr key={index} style={{
                            borderBottom: "1px solid #f3f4f6",
                            transition: "background 0.2s"
                          }}
                            onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                            onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
                          >
                            <td style={{ padding: "12px 16px", color: "#6b7280", fontSize: "14px" }}>
                              {index + 1}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#1f2937", fontSize: "14px", fontWeight: "500" }}>
                              {item?.first_name + ' ' + item?.last_name || "N/A"}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#f59e0b", fontSize: "14px", fontWeight: "500" }}>
                              {item?.missing_field || "N/A"}
                            </td>
                            <td style={{ padding: "12px 16px" }}>
                              <button
                                className="btn btn-sm"
                                style={{
                                  background: "#31876f",
                                  color: "#fff",
                                  border: "none",
                                  padding: "6px 16px",
                                  fontSize: "13px",
                                  borderRadius: "6px",
                                  fontWeight: "500",
                                  transition: "all 0.2s ease",
                                  cursor: "pointer"
                                }}
                                onClick={() => handleUpdateClick(item?.user_id)}
                                onMouseEnter={(e) => e.target.style.background = "#2d6f5a"}
                                onMouseLeave={(e) => e.target.style.background = "#31876f"}
                              >
                                Update
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <ReusableModal
        open={openPassengerModal}
        onClose={handleCloseModal}
        title="Update Passenger Details"
        maxWidth="md"
        hideCloseButton={true}
      >
        <div style={{ padding: "20px" }}>
          <form onSubmit={(e) => { e.preventDefault(); handleUpdatePassenger(); }}>
            <div className="mb-3">
              <label className="form-label">Passenger Name</label>
              <input
                type="text"
                className="form-control"
                name="first_name"
                value={passengerData.first_name}
                onChange={handlePassengerInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Gender</label>
              <select
                className="form-select"
                name="gender"
                value={passengerData.gender}
                onChange={handlePassengerInputChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Date of Birth</label>
              <div style={{ display: "block" }}>
                <DatePicker
                  selected={selectedDob}
                  onChange={handleDobChange}
                  dateFormat="MM/dd/yyyy"
                  placeholderText="MM/DD/YYYY"
                  className="form-control"
                  isClearable
                  required
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCloseModal}
                disabled={isUpdating}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn"
                style={{ background: "#31876f", color: "#fff" }}
                disabled={isUpdating}
              >
                {isUpdating ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Updating...
                  </>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </form>
        </div>
      </ReusableModal>
    </div>
  );
}

export default ScheduleUploading;
